import gql from 'graphql-tag';

export default gql`
    query GetConversationPreviewByUserId($input: ConversationPreviewInput, $offset: Int) {
        getConversationPreviewByUserId(input: $input, offset: $offset) {
            conversationId
            conversationName
            creationDate
            messageId
            drivers {
                name
                id
                driverCompanyId
            }
            driverName
            lastMessageRead
            totalCount
        }
    }
`;
